import moment from "moment";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";
import PhotosCarousel from "../../../metrics/meal-photos/components/PhotosCarousel";
import { useMealPhotosCarousel } from "../../../metrics/meal-photos/useMealPhotosCarousel";

function formatUtcDate(utcDate) {
  if (!utcDate) return "";
  const dateStr = utcDate.toString();
  if (dateStr.length !== 8) return "";
  const year = dateStr.substring(0, 4);
  const month = dateStr.substring(4, 6);
  const dayNum = dateStr.substring(6, 8);
  const date = moment(`${year}-${month}-${dayNum}`);
  return date.isValid() ? date.format("MMM D, YYYY") : "";
}

function LogMealPhotosCard({ mealPhotos, dailyStatId, utcDate, locals }) {
  const { t } = useTranslation("athlete-portal");

  const allPhotos = useMemo(() => {
    return Object.entries(mealPhotos?.mealPhotos || {}).flatMap(
      ([mealType, mealData]) =>
        (mealData.list || []).map((photo) => ({
          ...photo,
          mealType,
          mealTags: mealData.tags || [],
        }))
    );
  }, [mealPhotos]);

  const { showCarousel, selectedPhotoIndex, setSelectedPhotoIndex, openCarousel, closeCarousel } =
    useMealPhotosCarousel({ allPhotos, dailyStatId });

  if (!mealPhotos?.mealPhotos) return null;
  if (allPhotos.length === 0) return null;

  const displayPhotos = allPhotos.slice(0, 3);

  return (
    <>
      <div className="log-card log-card--meal-photos">
        <div className="log-card__header">
          <SvgIcon src="/img/new-icons/meal.svg" useCurrentColor={true} />
          {t("calendar.cards.mealPhotos.title")}
        </div>
        <div className="log-card__photos">
          {displayPhotos.map((photo) => {
            const src = photo.image?.s3Path || photo.s3Path || photo.url;
            return (
              <button
                key={photo._id}
                type="button"
                className="log-card__photo-link"
                onClick={() => openCarousel(photo._id)}
                aria-label={t("calendar.cards.mealPhotos.viewAria")}
              >
                <img
                  src={src}
                  alt={t("calendar.cards.mealPhotos.alt")}
                  className="log-card__photo-thumb"
                />
              </button>
            );
          })}
        </div>
      </div>

      <PhotosCarousel
        photos={allPhotos}
        selectedPhotoIndex={selectedPhotoIndex}
        isOpen={showCarousel}
        onClose={closeCarousel}
        onPhotoChange={setSelectedPhotoIndex}
        date={formatUtcDate(utcDate)}
        locals={locals}
        utcDate={utcDate}
      />
    </>
  );
}

export default LogMealPhotosCard;
